import { ChangeDetectorRef, Directive, EventEmitter, Input, Output } from '@angular/core';
import { Material } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { PanelStatus } from 'app/modules/florder/florder-edit-container/florder-edit.interface';
import { Destroyable } from '@dlw-int-mwi/eps-common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';

@Directive()
export abstract class FlorderMaterialLinesComponent<MATERIAL extends Material> extends Destroyable{
  @Input() materials: MATERIAL[];
  @Input() definitions: Definitions;
  @Input() panelStatus: PanelStatus;
  @Input() readonly: boolean;

  @Output() editMaterialClicked = new EventEmitter<MATERIAL>();
  @Output() removeMaterialClicked = new EventEmitter<MATERIAL>();

  connectorHeight: number;
  connectorWidth: number;
  labelPosition: 'top' | 'none' = 'none';

  constructor(protected breakpointObserver: BreakpointObserver, protected cd: ChangeDetectorRef) {
    super();
    breakpointObserver.observe(LayoutBreakpoints.bootstrapSmOrLess).pipe(this.takeUntilDestroyed()).subscribe((match) => {
      if (match.matches) {
        this.connectorHeight = 140;
        this.connectorWidth = 30;
      } else {
        this.connectorHeight = 50;
        this.connectorWidth = 20;
      }
      this.cd.markForCheck();
    });

    breakpointObserver.observe(LayoutBreakpoints.bootstrapSmOrLess).pipe(this.takeUntilDestroyed()).subscribe((match) => {
      if (match.matches) {
        this.labelPosition = 'top';
      } else {
        this.labelPosition = 'none';
      }
      this.cd.markForCheck();
    })
  }
}
